export const TAB_ASK_QUESTION = 'ask-question';
export const TAB_MAKE_OFFER = 'make-offer';

export const MAX_MESSAGE_LENGTH = 1400;

export const TITLE_ASK_QUESTION = 'Contact Seller';
export const TITLE_MAKE_OFFER = 'Make an Offer';
export const TAB_LABEL_ASK_QUESTION = 'Ask a Question';
export const SUBMIT_LABEL_ASK_QUESTION = 'Send Message';
export const TRUST_BADGE_TEXT = 'Identity verification\u00a0\u00a0•\u00a0\u00a0Secure payment';

export const SUBHEAD_ASK_QUESTION = location => `Send a message to Private Seller from ${location}`;
export const SUBHEAD_MAKE_OFFER = location => `Send your offer to Private Seller from ${location}`;
export const DEFAULT_MESSAGE = (vehicleTitle, formattedPrice) =>
  `I'd like to know if the ${vehicleTitle} you have listed on Edmunds.com for ${formattedPrice} is still available.`;

export const VALIDATION_ERRORS = {
  REQUIRED: 'This field is required',
  INVALID_EMAIL: 'Please enter a valid email address',
  INVALID_FIRST_NAME: 'Please enter a valid first name',
  INVALID_LAST_NAME: 'Please enter a valid last name',
};

export const SUCCESS_MODAL_LABEL = 'Message Sent';
export const SUCCESS_MODAL_TITLE = 'Your message has been sent!';
export const SUCCESS_MODAL_TEXT = 'You\u2019ll be notified by email when the Private Seller sends a response.';
export const CLOSE_BUTTON_LABEL = 'Close';

export const PRIVACY_NOTE_TEXT =
  'Your first name and message will be shared with this seller. By sending a message you agree to our ';
export const GUIDELINES_LINK_TEXT = 'Guidelines';
export const GUIDELINES_LINK_URL = '/sell-car/private/marketplace-guidelines/';
export const PRIVACY_LINK_TEXT = 'Our collection and use of your personal information';
export const PRIVACY_LINK_URL = '/about/privacy.html';

export const ERROR_MESSAGE_USER_BLOCKED = 'Conversation is not active';
export const ERROR_STATUS_TOO_MANY_REQUESTS = 429;
